import { Link } from "react-router-dom";
import type { Actor } from "@/mocks/actors";

interface ActorMiniCardProps {
  actor: Actor;
}

export default function ActorMiniCard({ actor }: ActorMiniCardProps) {
  return (
    <Link
      to={`/detail/actor/${actor.id}`}
      className="group flex flex-col items-center gap-2 text-center"
    >
      <span className="w-20 h-20 rounded-full overflow-hidden border border-background-200 bg-background-200">
        <img
          src={actor.avatar}
          alt={`${actor.name}头像`}
          title={`${actor.name} - 葵司演员资料`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </span>
      <span className="text-sm text-foreground-800 group-hover:text-accent-600 transition-colors">
        {actor.name}
      </span>
    </Link>
  );
}